import React from 'react';
import styles from '../styles.module.scss';

const STEPS = [
    { number: 1, label: '情報入力' },
    { number: 2, label: '査定結果' },
];

type StepProgressProps = {
    currentStep: number;
};

export const StepProgress = ({ currentStep }: StepProgressProps) => {
    return (
        <div className={styles.progressWrapper}>
            <div className={styles.progressDots}>
                {STEPS.map((step, index) => (
                    <React.Fragment key={step.number}>
                        <div
                            className={`${styles.progressDot} ${
                                step.number <= currentStep
                                    ? styles.progressDotActive
                                    : styles.progressDotInactive
                            }`}
                        >
                            {step.number}
                        </div>
                        {index < STEPS.length - 1 && <div className={styles.progressLine} />}
                    </React.Fragment>
                ))}
            </div>
            <div className={styles.progressLabels}>
                {STEPS.map((step) => (
                    <span
                        key={step.number}
                        className={`${styles.progressLabel} ${
                            step.number <= currentStep
                                ? styles.progressLabelActive
                                : styles.progressLabelInactive
                        }`}
                    >
                        {step.label}
                    </span>
                ))}
            </div>
        </div>
    );
};
